






import { defineComponent, ref } from '@vue/composition-api';
import { useActions } from 'vuex-composition-helpers';

export default defineComponent({
  setup(props, { emit }) {
    const { deleteContact } = useActions(['deleteContact']);
    const deleting = ref<boolean>(false);

    return {
      deleting,
      deleteContact: async (contactId: string) => {
        deleting.value = true;
        await deleteContact(contactId);
        deleting.value = false;

        emit('deleted');
      },
    };
  },
});
